export default __webpack_public_path__ + "static/media/milestone 100.767e83e4.svg";